import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { Company } from "../Entities/Company/Company";
import { CompanyInterface } from "../Entities/Company/CompanyInterface";
import { AttachmentInterface } from "../Entities/Attachment/AttachmentInterface";
import AttachmentFactory from "./AttachmentFactory";

class CompanyFactory extends Factory implements FactoryInterface {

  public create(data: any): CompanyInterface {
    const attachments: AttachmentInterface[] = AttachmentFactory.createFromArray(data.attachments);

    return new Company({
      id: data.id || 0,
      amazonFolderName: data.amazonFolderName,
      name: data.name || "",
      shortName: data.shortName || "",
      displayName: data.name || "",
      email: data.email || "",
      agencyId: data.agencyId || 0,
      avatar: this.getAvatar(attachments, "company"),
      personIds: this.getPersons(data.contacts),
      propertyIds: this.getProperties(data.properties),
      attachments: attachments,
      phone: data.phone || "",
      address: this.generateAddress(data.address),
      updatedAt: new Date(data.updatedAt),
      mainBankAccountId: data.mainBankAccountId || "",
      mainBankAccountName: data.mainBankAccountName || "",
      agencyBankAccountId: data.mainBankAccountId || "",
      agencyBankAccountName: data.mainBankAccountName || "",
      companyBankId: data.companyBankId,
      removed: data.removed,
      note: data.note,
      bic: data.bic,
      companyRegistry: data.companyRegistry,
      vat: data.vat,
      website: data.website,
      savingsAccount: data.savingsAccount,
      generalContactId: data.generalContactId,
      contacts: data?.contacts,
      contactsForCompanies: data?.contactsForCompanies,
      invoiceEmailAddress: data.invoiceEmailAddress,
      invoiceEmailSubject: data.invoiceEmailSubject,
      companyType: data.companyType,
      bankAccounts: data.bankAccounts,
      financialStartDate: data.financialStartDate,
    });
  }

  public reinitialize(data: any): CompanyInterface {
    return new Company({
      ...data,
      avatar: this.getAvatar(data.attachments, "company")
    });
  }
}

export default new CompanyFactory();
